import store from "../plugins/store";
import myApi from "../plugins/axios";

// function getAmountTotal(product){
//     if(product.discount_g && !product.code_offer){
//         if(product.discount_g.discount_id){
//         return product.discount_g.new_amount;
//         }else{
//         if(product.discount_g.type_discount == 1){//%
//             return product.precio_general - (product.precio_general*product.discount_g.discount*0.01);
//         }else{
//             return product.precio_general - product.discount_g.discount;
//         }
//         }
//     }
//     if(product.code_offer){
//         if(product.code_offer.new_amount){
//             return product.code_offer.new_amount;
//             // percentage
//         }else{
//             if(product.code_offer.type_discount == 1){//%
//                 return product.precio_general - (product.precio_general*product.code_offer.discount*0.01);
//             }else{
//                 return product.precio_general - product.code_offer.discount;
//             }
//         }
//     }
//     return product.precio_general;
// }
let addQueue = Promise.resolve();

function getAmountTotal(product) {
  if (product.discount_g && !product.code_offer) {
    if (product.discount_g.discount_id || product.discount_g.kit_id) {
      return Number(product.discount_g.new_amount.toFixed(2));
      // percentage
    } else {
      if (product.discount_g.type_discount == 1) {
        //%
        return Number(
          (
            product.precio_general -
            product.precio_general * product.discount_g.discount * 0.01
          ).toFixed(2)
        );
      } else {
        return Number(
          (product.precio_general - product.discount_g.discount).toFixed(2)
        );
      }
    }
  }
  if (product.code_offer) {
    if (product.code_offer.new_amount) {
      return Number(product.code_offer.new_amount.toFixed(2));
      // percentage
    } else {
      if (product.code_offer.type_discount == 1) {
        //%
        return Number(
          (
            product.precio_general -
            product.precio_general * product.code_offer.discount * 0.01
          ).toFixed(2)
        );
      } else {
        return Number(
          (product.precio_general - product.code_offer.discount).toFixed(2)
        );
      }
    }
  }
  return product.precio_general;
}
function getTypeDiscount(product) {
  if (product.discount_g && !product.code_offer) {
    if (product.discount_g.discount_id || product.discount_g.kit_id) {
      return 1;
    } else {
      return product.discount_g.type_discount;
    }
  }
  if (product.code_offer) {
    if (product.code_offer.new_amount) {
      return 1;
    } else {
      return product.code_offer.type_discount;
    }
  }
  return null;
}
function getAmountDiscount(product) {
  if (product.discount_g) {
    if (product.discount_g.discount_id || product.discount_g.kit_id) {
      return product.discount_g.percentage;
    } else {
      if (product.discount_g.type_discount == 1) {
        //%
        return product.discount_g.discount;
      } else {
        return product.discount_g.discount;
      }
    }
  }
  if (product.code_offer) {
    if (product.code_offer.new_amount) {
      return product.code_offer.percentage;
    } else {
      if (product.code_offer.type_discount == 1) {
        //%
        return product.code_offer.discount;
      } else {
        return product.code_offer.discount;
      }
    }
  }
  return 0;
}

function register_guest(PRODUCT, quantity = 1) {
  return {
    title: PRODUCT.title,
    imagen: PRODUCT.imagen,
    uniqd: PRODUCT.uniqd,
    slug: PRODUCT.slug,
    avg_rating: PRODUCT.avg_rating,
    reviews_count: PRODUCT.reviews_count,
    quantity: quantity,
    is_kit: PRODUCT.is_kit,
    kit_id: PRODUCT.kit_id,
    price_unit: PRODUCT.precio_general_old
      ? PRODUCT.precio_general_old
      : PRODUCT.precio_general,
    is_pc_build: PRODUCT.is_pc_build ? 1 : null,
    subtotal: PRODUCT.precio_general_old
      ? PRODUCT.precio_general
      : getAmountTotal(PRODUCT),
    total:
      (PRODUCT.precio_general_old
        ? PRODUCT.precio_general
        : getAmountTotal(PRODUCT)) * quantity,
    type_discount:
      PRODUCT.precio_general_old && PRODUCT.type_discount
        ? PRODUCT.type_discount
        : getTypeDiscount(PRODUCT),
    discount:
      PRODUCT.precio_general_old && PRODUCT.discount
        ? PRODUCT.discount
        : getAmountDiscount(PRODUCT),
    code_cupon: null,
    code_discount: PRODUCT.discount_g ? PRODUCT.discount_g.uniqd : null,
    code_offer: PRODUCT.discount_g ? PRODUCT.discount_g.uniqd : null,
    sucursales: PRODUCT.sucursales,
    type_discount_old: getTypeDiscount(PRODUCT),
    discount_old: getAmountDiscount(PRODUCT),
  };
}

function register_client(PRODUCT, quantity = 1) {
  return {
    user_id: PRODUCT.user_id,
    title: PRODUCT.title,
    imagen: PRODUCT.imagen,
    product_id: PRODUCT.product_id ? PRODUCT.product_id : PRODUCT.id,
    uniqd: PRODUCT.uniqd,
    slug: PRODUCT.slug,
    quantity: quantity,
    avg_rating: PRODUCT.avg_rating,
    reviews_count: PRODUCT.reviews_count,
    price_unit: PRODUCT.precio_general_old
      ? PRODUCT.precio_general_old
      : PRODUCT.precio_general,
    is_pc_build: PRODUCT.is_pc_build ? 1 : null,
    is_kit: PRODUCT.is_kit,
    kit_id: PRODUCT.kit_id,
    subtotal: PRODUCT.precio_general_old
      ? PRODUCT.precio_general
      : getAmountTotal(PRODUCT),
    total:
      (PRODUCT.precio_general_old
        ? PRODUCT.precio_general
        : getAmountTotal(PRODUCT)) * quantity,
    type_discount:
      PRODUCT.precio_general_old && PRODUCT.type_discount
        ? PRODUCT.type_discount
        : getTypeDiscount(PRODUCT),
    discount:
      PRODUCT.precio_general_old && PRODUCT.discount
        ? PRODUCT.discount
        : getAmountDiscount(PRODUCT),
    code_cupon: null,
    code_discount: PRODUCT.discount_g ? PRODUCT.discount_g.uniqd : null,
    code_offer: PRODUCT.discount_g ? PRODUCT.discount_g.uniqd : null,
    sucursales: PRODUCT.sucursales,
    type_discount_old: getTypeDiscount(PRODUCT),
    discount_old: getAmountDiscount(PRODUCT),
  };
}

function update(CART) {
  return {
    cart_id: CART.id,
    user_id: CART.user_id,
    title: CART.product.title,
    imagen: CART.product.image,
    product_id: CART.product_id,
    uniqd: CART.product.uniqd,
    slug: CART.product.slug,
    quantity: CART.quantity,
    avg_rating: CART.product.avg_rating,
    reviews_count: CART.product.reviews_count,
    price_unit: CART.price_unit,
    is_pc_build: CART.is_pc_build,
    kit_id: CART.kit_id,
    kit: CART.kit,
    is_kit: CART.is_kit,
    subtotal: CART.subtotal,
    total: CART.total,
    type_discount: CART.type_discount,
    discount: CART.discount,
    code_cupon: CART.code_cupon,
    code_discount: CART.code_discount,
    code_offer: CART.code_discount,
    product: CART.product,
    sucursales: CART.product.sucursales,
    id: CART.id,
    type_discount_old: CART.type_discount_old,
    discount_old: CART.discount_old,
  };
}

export default {
  register_guest: (PRODUCT) => {
    return register_guest(PRODUCT);
  },
  register_client: (PRODUCT, quantity = 1) => {
    return register_client(PRODUCT, quantity);
  },
  update: (CART) => {
    return update(CART);
  },

  add: async (CARTS, PRODUCTY, emitter, notify, cookies, quantity = 1) => {
    const uniqd = String(PRODUCTY.uniqd);
    const delta = Number(quantity || 1);

    const isLogged =
      (store.getters && store.getters.loggedIn === true) ||
      !!localStorage.getItem('user');

    console.groupCollapsed(`[CART/add] start -> uniqd:${uniqd}`);
    console.time(`[CART/add] time`);
    console.log('[CART/add] params', { uniqd, delta, isLogged, hasEmitter: !!(emitter && emitter.emit) });
    console.log('[CART/add] PRODUCTY snapshot', {
      id: PRODUCTY?.id ?? PRODUCTY?.product_id ?? null,
      uniqd: PRODUCTY?.uniqd,
      hasDiscountG: !!PRODUCTY?.discount_g,
      hasCodeOffer: !!PRODUCTY?.code_offer,
      is_kit: PRODUCTY?.is_kit,
      is_pc_build: PRODUCTY?.is_pc_build,
    });

    addQueue = addQueue.then(async () => {
      // =========================
      // 1) INVITADO: storage local
      // =========================
      if (!isLogged) {
      let LIST = Array.isArray(CARTS) ? [...CARTS] : [];
      const idx = LIST.findIndex(p => String(p.uniqd) === uniqd);
      const curr = idx !== -1 ? Number(LIST[idx].quantity || 1) : 0;
      const newQty = curr + delta;

      console.log('[CART/add][guest] validating before add', { idx, curr, delta, newQty });

      
      try {
        const minimalToValidate = [...LIST];
        
        if (idx !== -1) {
          minimalToValidate[idx] = { uniqd, quantity: newQty };
        } else {
          
          minimalToValidate.push({ uniqd, quantity: Math.max(1, delta) });
        }

        
        const payload = { 
          CARTS: minimalToValidate.map(m => ({ 
            uniqd: String(m.uniqd), 
            quantity: Number(m.quantity || 1) 
          })) 
        };

       
        
        await myApi.post('ecommerce/process_cart_sucursal', payload);
        
     
        
      } catch (e) {



        if (e?.response?.status === 409) {
          console.log('error', e)
          const errorData = e?.response?.data?.error || {};
          const productos = e?.response?.data?.products || [];
          
         
          const problematicProduct = productos.find(
            p => String(p.uniqd) === uniqd
          );

          if (problematicProduct) {
            const stockDisponible = Number(problematicProduct.quantity_sucursal || 0);
            
            if (stockDisponible === 0) {
              notify({
                title: 'Producto sin stock disponible',
                text: `"${PRODUCTY.title}" no tiene unidades disponibles en este momento.`,
                type: 'error',
                duration: 5000,
              });
            } else if (newQty > stockDisponible) {
              notify({
                title: 'No disponible',
                text: 'Stock insuficiente',
                type: 'error',
                duration: 5000,
              });
            } else {
              notify({
                title: 'No se puede agregar el producto',
                text: errorData || 'Límite de productos alcanzado para esta oferta.',
                type: 'error',
                duration: 5000,
              });
            }
          } else {
            notify({
              title: 'No se puede agregar el producto',
              text: errorData || 'Este producto no está disponible actualmente.',
              type: 'error',
              duration: 4500,
            });
          }
        } else {
          notify({
            title: 'Error de validación',
            text: 'No se pudo verificar la disponibilidad del producto.',
            type: 'error',
            duration: 4000,
          });
        }

        console.timeEnd(`[CART/add] time`);
        console.groupEnd();
        return true; 
      }

      
      console.log('[CART/add][guest] validation passed, adding to local storage');

      if (idx !== -1) {
        if (delta === -1 && curr <= 1) {
          notify({ 
            title: 'Cantidad de producto no válida', 
            type: 'error', 
            duration: 3000 
          });
          console.timeEnd(`[CART/add] time`);
          console.groupEnd();
          return true;
        }
        LIST[idx].quantity = newQty;
        LIST[idx].total = Number((LIST[idx].subtotal * newQty).toFixed(2));
      } else {
        if (LIST.length >= 3) {
          notify({ 
            title: 'Para agregar más productos al carrito inicia sesión o crea una cuenta.', 
            duration: 4500, 
            type: 'error' 
          });
          console.timeEnd(`[CART/add] time`);
          console.groupEnd();
          return true;
        }
        const row = register_guest(PRODUCTY, Math.max(1, delta));
        LIST.push(row);
      }

      if (!store.getters.loggedIn) {
        localStorage.setItem('carts', JSON.stringify(LIST));
      }
      
      emitter.emit('cart-shop', LIST);

      notify({
        title: delta === -1 ? 'Cantidad disminuida' : 'Producto agregado al carrito',
        duration: 4500,
        type: delta === -1 ? 'warn' : 'success',
      });

      console.timeEnd(`[CART/add] time`);
      console.groupEnd();
      return true;
    }
      // =========================
      // 2) LOGEADO: validar + POST /carts
      // =========================
      const idx = Array.isArray(CARTS) ? CARTS.findIndex(p => String(p.uniqd) === uniqd) : -1;
      const curr = idx !== -1 ? Number(CARTS[idx].quantity || 0) : 0;
      console.log('[CART/add][logged] local index/curr', { idx, curr, delta });

      if (delta === -1 && curr <= 1) {
        notify({ title: 'Cantidad de producto no válida', type: 'error', duration: 3000 });
        console.warn('[CART/add][logged] invalid decrement', { curr, delta });
        console.timeEnd(`[CART/add] time`); console.groupEnd();
        return true;
      }
      const newQty = Math.max(1, curr + delta);
      console.log('[CART/add][logged] newQty', { newQty });

      // 2.1 Validación en backend
      try {
        const payloadValid = {
          uniqd: uniqd,
          uniqd_product: uniqd,
          quantity: newQty,
          cart_id: idx !== -1 ? (CARTS[idx].cart_id || null) : null,
        };
        console.log('[CART/add][logged] calling valid_carts_add_cart', payloadValid);

        const resp = await myApi.post('ecommerce/valid_carts_add_cart/', payloadValid);

        console.log('[CART/add][logged] validation response', { status: resp?.status, data: resp?.data });
        if (resp?.data?.message == 403) {
          notify({ title: resp.data.message_text, duration: 4500, type: 'error' });
          console.warn('[CART/add][logged] backend says 403 business rule', resp?.data);
          console.timeEnd(`[CART/add] time`); console.groupEnd();
          return true;
        }
      } catch (e) {
        console.error('[CART/add][logged] validation error', {
          status: e?.response?.status,
          data: e?.response?.data,
          message: e?.message,
        });
        notify({
          title: `${ e?.response?.data?.message_text } `,
          duration: 4500,
          type: 'error',
        });
        console.timeEnd(`[CART/add] time`); console.groupEnd();
        return true;
      }

      // 2.2 Construye el payload (fallback minimal = enviar DELTA=1)
      let data;
      if (idx !== -1) {
        const prev = Number(CARTS[idx].quantity || 0);

        const hasProduct = !!CARTS[idx]?.product;
        const hasTotals =
          CARTS[idx] && 'price_unit' in CARTS[idx] && 'subtotal' in CARTS[idx] && 'total' in CARTS[idx];

        console.log('[CART/add][logged] building existing item', { hasProduct, hasTotals });

        if (hasProduct && hasTotals) {
          // Camino original con update() -> cantidad absoluta
          const clone = { ...CARTS[idx], quantity: newQty };
          data = update(clone);
          data.qty_old = prev;
        } else {
          // Fallback: item local MINIMAL -> enviar SOLO el delta (= 1 por click)
          const qtyDelta = Math.max(1, delta); // normalmente 1
          PRODUCTY.user_id = store.state.user?.id;
          data = register_client(PRODUCTY, qtyDelta);
          if (CARTS[idx]?.cart_id) data.cart_id = CARTS[idx].cart_id;
          data.qty_old = prev;
          data._mode = 'increment'; // pista opcional para el back
          console.log('[CART/add][logged] fallback register_client() because item was minimal (sending delta)', { qtyDelta });
        }
      } else {
        // Nuevo item -> 1 (o delta) está bien; tu lógica original
        PRODUCTY.user_id = store.state.user?.id;
        data = register_client(PRODUCTY, newQty);
      }

      // Resumen seguro del payload
      try {
        const dbg = {
          cart_id: data?.cart_id ?? null,
          product_id: data?.product_id ?? null,
          uniqd: data?.uniqd ?? null,
          quantity: data?.quantity ?? null,
          subtotal: data?.subtotal ?? null,
          total: data?.total ?? null,
          type_discount: data?.type_discount ?? null,
          discount: data?.discount ?? null,
          code_cupon: data?.code_cupon ?? null,
          code_discount: data?.code_discount ?? null,
          code_offer: data?.code_offer ?? null,
          _mode: data?._mode ?? null,
        };
        console.log('[CART/add][logged] payload summary', dbg);
      } catch (errDbg) {
        console.warn('[CART/add][logged] payload summary error (non-breaking)', errDbg);
      }

      // 2.3 Emitir al Header (ahí ocurre el POST /ecommerce/carts/)
      console.log('[CART/add][logged] emitting save-cart');
      emitter.emit('save-cart', data);
      console.log('[CART/add][logged] save-cart emitted OK');

      // 2.4 Notificación
      notify({
        title: delta === -1 ? 'Cantidad disminuida' : 'Producto agregado al carrito',
        duration: 4500,
        type: delta === -1 ? 'warn' : 'success',
      });

      console.timeEnd(`[CART/add] time`); console.groupEnd();
      return true;
    }).catch(err => {
      console.error('[CART/add] queue error', err);
      notify({
        title: 'Hubo un problema al procesar el producto. Intente nuevamente :)',
        duration: 4500,
        type: 'error',
      });
      console.timeEnd(`[CART/add] time`); console.groupEnd();
      return true;
    });

    return true;
  },

  addDinamic: (CARTS, PRODUCTY, emitter, notify, cookies, quantity = 1) => {
    console.groupCollapsed('[CART/addDinamic] start'); console.log({ uniqd: PRODUCTY?.uniqd, quantity });
    if (PRODUCTY.sucursales) {
      const noDisponible = PRODUCTY.sucursales.every(
        (s) => Number(s.stock) < Number(quantity || 1)
      );
      if (noDisponible) {
        emitter.emit(
          "add-error-cart-shop",
          "La cantidad de producto que deseas no se encuentra disponible en este momento. Te sugerimos intentar con una cantidad diferente o ponerte en contacto con servicio al cliente para obtener una solución"
        );
        console.warn('[CART/addDinamic] stock not available');
        console.groupEnd();
        return;
      }
    }

    const key = String(PRODUCTY.uniqd);
    let INDEX = CARTS.findIndex((p) => String(p.uniqd) === key);
    console.log('[CART/addDinamic] index', { key, INDEX });

    const qty = Math.max(1, Number(quantity || 1));
    if (INDEX !== -1) {
      CARTS[INDEX].quantity = qty;
      console.log('[CART/addDinamic] updated quantity', { qty });
    } else {
      CARTS.push({ uniqd: key, quantity: qty });
      console.log('[CART/addDinamic] pushed minimal', { uniqd: key, qty });
    }

    const MIN = CARTS.filter((x) => x && x.uniqd).map((x) => ({
      uniqd: String(x.uniqd),
      quantity: Number(x.quantity || 1),
    }));

    if (!store.getters.loggedIn) {
      localStorage.setItem("carts", JSON.stringify(MIN));
      console.log('[CART/addDinamic] saved minimal to localStorage', MIN);
    }

    emitter.emit("cart-shop", MIN);
    console.log('[CART/addDinamic] emitted cart-shop', MIN);

    notify({
      title: "Producto agregado al carrito",
      duration: 4500,
      type: "success",
    });
    console.groupEnd();
  },

  deleteCoupon: (CARTS, COUPON, emitter, notify, cookies) => {
    console.groupCollapsed('[CART/deleteCoupon] start', { COUPON, isLogged: !!store.getters.loggedIn });
    if (!store.getters.loggedIn) {
      CARTS = CARTS.map((cart) => {
        if (cart.code_cupon == COUPON) {
          if (cart.code_offer) {
            cart.code_cupon = null;
            cart.code_discount = cart.code_offer;
            cart.discount = cart.discount_old;
            cart.type_discount = cart.type_discount_old;

            let subtotal = 0;
            if (cart.type_discount == 1) {
              subtotal = Number(
                (
                  cart.price_unit -
                  cart.price_unit * cart.discount * 0.01
                ).toFixed(2)
              );
            } else {
              subtotal = Number((cart.price_unit - cart.discount).toFixed(2));
            }

            cart.subtotal = subtotal;
            cart.total = Number((cart.subtotal * cart.quantity).toFixed(2));
            console.log('[CART/deleteCoupon] removed coupon (kept offer)', { subtotal: cart.subtotal, total: cart.total });
          } else {
            cart.code_cupon = null;
            cart.discount = 0;
            cart.type_discount = null;
            cart.subtotal = cart.price_unit;
            cart.total = cart.subtotal * cart.quantity;
            console.log('[CART/deleteCoupon] removed coupon (no offer)', { subtotal: cart.subtotal, total: cart.total });
          }
        }
        return cart;
      });
      console.log('[CART/deleteCoupon] cookies param', cookies);
      if (!store.getters.loggedIn) localStorage.setItem("carts", JSON.stringify(CARTS));
      emitter.emit("cart-shop", CARTS);
      console.log('[CART/deleteCoupon] updated local and emitted cart-shop', CARTS);
      notify({
        title: "Carrito de compra",
        text: `A tu carrito se le quito el cupon '${COUPON}' correctamente!`,
        duration: 4500,
        type: "success",
      });
    } else {
      CARTS = CARTS.map((cart) => {
        if (cart.code_cupon == COUPON) {
          cart.code_cupon = null;
          cart.discount = 0;
          cart.type_discount = null;
          cart.subtotal = cart.price_unit;
          cart.total = cart.subtotal * cart.quantity;
        }
        return cart;
      });
      setTimeout(() => {
        emitter.emit("update-carts", CARTS);
        console.log('[CART/deleteCoupon] emitted update-carts (logged)', CARTS);
      }, 25);
    }
    console.groupEnd();
  },

  getAmountTotalProduct: (product) => {
    product.precio_general = Number(product.precio_general);
    const amount = getAmountTotal(product);
    console.log('[CART/getAmountTotalProduct]', {
      uniqd: product?.uniqd, precio_general: product?.precio_general, result: amount
    });
    return amount;
  },
};

